import React from 'react';
import styled from 'styled-components';
import { HorizontalCard, HorizontalCardInnerWrapper } from '../../../../view/HorizontalCard';
import { Container } from '../../../../view/Containers';
import { HeaderWithSeparator } from '../../../../view/TextSubHeaders';
import shop from '../../../../img/MainPage/shop.png';
import website from '../../../../img/MainPage/website.png';
import { Paragraph } from '../../../../view/Paragraph';
import { BasicRoundedInnerLink, BasicRoundedLink } from '../../../../view/Buttons';
import { Margin } from '../../../../view/Margin';

const ProductOrderContainer = styled(Container)`
  display: flex;
  @media screen and (max-width: 1200px) {
    display: block;
  }
`;

export const ProductOrdersPlace = (): JSX.Element => (
  <>
    <ProductOrderContainer>
      <HorizontalCard url={shop} />
      <HorizontalCard>
        <HorizontalCardInnerWrapper>
          <HeaderWithSeparator as="h2" header=" OWCA Showroom FOOD" upperSubHeader="Gdzie kupić" />
          <Paragraph>
            <>
              Nasze produkty zakupisz w zaprzyjazionym stoisku na Mokowtowie w Warszawie. Owca showroom
              food znajduje się na ul. Kłobuckiej 8c/u3. Sprawdź godziny otwarcia.
            </>
          </Paragraph>
          <Margin height={25} />
          <BasicRoundedLink href="/contactUs">
            Kontakt
          </BasicRoundedLink>
        </HorizontalCardInnerWrapper>
      </HorizontalCard>
    </ProductOrderContainer>
    <ProductOrderContainer>
      <HorizontalCard>
        <HorizontalCardInnerWrapper>
          <HeaderWithSeparator as="h2" header="Sklep internetowy" upperSubHeader="Gdzie kupić" />
          <Paragraph>
            Wększość naszego asortymentu możesz zamówić przez sklep internetowy. Syropy, soki, dżemy, kiszonki,
            oleje, ale też świeże mleko i warzywa - wszytko to przygotujemy zgodnie ze złożonym przez Ciebie zamówieniem i wyślemy pod wskazany adres
          </Paragraph>
          <Margin height={25} />
          <BasicRoundedLink href="https://www.sklep.owocowo.com.pl/">
            Odkrywaj
          </BasicRoundedLink>
        </HorizontalCardInnerWrapper>
      </HorizontalCard>
      <HorizontalCard url={website} />
    </ProductOrderContainer>
  </>
);
